import React from 'react';
import CourseEntryReq from '../components/courseCompare/CourseEntryReq';

export const calculateFees = (course, courseDetails, formData, configData) => {
  if (!course?.fees) return '-';

  // console.log({ course, formData });

  // Get base fee based on nationality
  let baseFee =
    formData.nationality === 'malaysian'
      ? parseInt(course.fees.malaysian)
      : parseInt(course.fees.international);

  let totalFee = baseFee;
  // console.log({ totalFee });

  // Apply merit award discount
  if (formData.meritAwards && formData.meritAwards !== 'none') {
    const discountPercent = parseInt(formData.meritAwards) / 100;
    totalFee = totalFee * (1 - discountPercent);
  }
  // console.log({ totalFee });

  // Subtract PTPTN loan amount
  console.log({ courseDetails });
  if (formData.ptptnLevel && courseDetails.fees) {
    const ptptnAmount = course.courseLabel.startsWith('Diploma')
      ? configData.ptptnValues[formData.ptptnLevel.value]?.diploma
      : configData.ptptnValues[formData.ptptnLevel.value]?.degree;
    const ptptnLoanAmount = parseInt(ptptnAmount);
    if (ptptnLoanAmount) {
      const totalLoanAmount =
        ptptnLoanAmount *
        parseInt(courseDetails.fees[formData.nationality].length);
      console.log({
        totalLoanAmount,
        ptptnLoanAmount,
        years: courseDetails.fees[formData.nationality].length,
        nationality: formData.nationality,
      });
      totalFee = Math.max(0, totalFee - totalLoanAmount);
    }
  }
  return totalFee.toFixed(0);
};

export const SECTION_LABELS = [
  'Course',
  'Duration',
  'Entry Requirements',
  'Career Options',
  'Fees',
  '',
];

const formatDuration = (courseDetails) => {
  let durationString = '';
  if (courseDetails.duration_year > 0) {
    durationString = `${courseDetails.duration_year} year${
      courseDetails.duration_year > 1 ? 's' : ''
    }`;
  }
  if (courseDetails.duration_month > 0) {
    durationString += ` ${courseDetails.duration_month} month${
      courseDetails.duration_month > 1 ? 's' : ''
    }`;
  }
  if (courseDetails.duration_week > 0) {
    durationString += ` ${courseDetails.duration_week} week${
      courseDetails.duration_week > 1 ? 's' : ''
    }`;
  }
  return durationString;
};

export const getSectionConfig = (course) => {
  return [
    {
      label: 'Course',
      content: <h3 style={{ margin: 0 }}>{course.courseLabel}</h3>,
    },
    {
      label: 'Duration',
      content: (
        <h3 style={{ margin: 0 }}>{formatDuration(course.courseDetails[0])}</h3>
      ),
    },
    {
      label: 'Entry Requirements',
      content: course.entryReq ? (
        <CourseEntryReq entryReq={course.entryReq} />
      ) : (
        <div>No entry requirements available</div>
      ),
    },
    {
      label: 'Career Options',
      content: (
        <>
          {course.careerOptions.slice(0, 8).map((option, index) => (
            <div key={index} style={{ marginBottom: 4, fontSize: '12px' }}>
              {option}
            </div>
          ))}
        </>
      ),
    },

    {
      label: 'Fees',
      content: (
        <>
          <div className="fee-label">
            <span>Malaysian:</span> RM{' '}
            {parseInt(course.fees.malaysian).toLocaleString()}
          </div>
          <div className="fee-label">
            <span>International:</span> RM{' '}
            {parseInt(course.fees.international).toLocaleString()}
          </div>
        </>
      ),
    },
    {
      label: 'Apply Now',
      content: (
        <>
          <div style={{ width: '100%', textAlign: 'center' }}>
            <a
              className="btn btn-primary"
              href="https://admissions.apu.edu.my/"
              target="_blank"
            >
              Apply Now
            </a>
          </div>
        </>
      ),
    },
  ];
};
